// @flow
import React, { Component } from 'react';
import _ from 'lodash';
import {
  Form,
  Grid,
  Icon,
  Label,
} from 'semantic-grab-ui/src';
import { TemplateInfo, TemplateParams } from 'types/trident-campaigns';
import formComponent from 'components/decorators/form_component';
import FormInputWithError from 'components/form/FormInputWithError';
import LocalizedMenu from 'omega-rtc/components/form/LocalizedMenu';
import { urlDeeplinkRegex } from './constants/rules';

type Props = {
  templateParams: TemplateParams,
  templateInfo: TemplateInfo,
  onChange: Function,
  error: Object,
};

// TemplateParamsForm is the form for selecting language and filling in variable values for hedwig template
@formComponent()
export default class TemplateParamsForm extends Component {
  props: Props;

  constructor(props: Props) {
    super(props);
    this.state = {
      params: this.props.templateParams || {},
    };
  }

  componentWillReceiveProps(nextProps: Props) {
    this.setState({
      params: nextProps.templateParams || {},
    });
  }

  getAddedLanguages = (): Array<string> => {
    return _.keys(this.state.params);
  };

  handleUpdateLanguages = (langs: Array<string>) => {
    const currentLangs = this.getAddedLanguages();
    const toAddLangs = _.filter(langs, v => {
      return currentLangs.indexOf(v) === -1;
    });
    const toRemoveLangs = _.filter(currentLangs, v => {
      return langs.indexOf(v) === -1;
    });

    toAddLangs.forEach(lang => {
      _.set(this.state.params, lang, {});
    });
    toRemoveLangs.forEach(lang => {
      _.unset(this.state.params, lang);
    });

    this.props.onChange(this.state.params);
  };

  renderMenuIcons(): Object {
    return _.reduce(
      this.props.error,
      (icons, error, language) => {
        if (!error.allFieldsDirty) {
          return Object.assign({}, icons, { [language]: null });
        }

        const icon = !error.totalError ? (
          <Icon name="check circle" color="green" size="large" />
        ) : (
          <Label color="red">{error.totalError}</Label>
        );
        return Object.assign({}, icons, { [language]: icon });
      },
      {},
    );
  }

  getTemplateInfoFromParams = (params: TemplateParams) => {
    const languageVariables = {};
    _.map(params, (vars, lang) => {
      _.set(languageVariables, `${lang}.variables`, _.keys(vars));
    });
    return {
      languageVariables,
    };
  };

  onInputChange = (event, data) => {
    let { value } = data;

    const isUrlDeepLink = urlDeeplinkRegex().test(value);

    /**
     * If the value is being detected as either link or deeplink
     * it will be automatically removed beginning, ending <space> of string
     */
    if (isUrlDeepLink && value) {
      value = value.trim();
    }

    _.set(this.state.params, data.name, value);
    this.props.onChange(this.state.params);
  };

  render() {
    const addedLangs = this.getAddedLanguages();
    const languagesInTemplate = _.keysIn(
      _.get(this.props.templateInfo, 'languageVariables', {}),
    );
    let templateInfo = this.props.templateInfo;
    let allowAddLang = true;
    if (_.isEmpty(templateInfo)) {
      allowAddLang = false; // if template info is empty, that means the template is not fetched, we shouldn't allow adding language
      templateInfo = this.getTemplateInfoFromParams(this.state.params);
    }

    const localizedContents = _.reduce(
      addedLangs,
      (result, language) => {
        const payloadFields = _.get(
          templateInfo,
          `languageVariables.${language}.variables`,
          [],
        );
        const content = payloadFields.map(field => {
          return (
            <div key={field}>
              <br />
              <br />
              <FormInputWithError
                name={`${language}.${field}`}
                {...this.props}
              >
                <Form.Input
                  required
                  label={field}
                  value={_.get(
                    this.state.params,
                    `${language}.${field}`,
                    '',
                  )}
                  // onChange={this.props.handleInputChange}
                  onChange={this.onInputChange}
                  onBlur={this.props.handleControlBlur}
                />
              </FormInputWithError>
            </div>
          );
        });
        return Object.assign({}, result, { [language]: content });
      },
      {},
    );

    return (
      <Grid>
        <Grid.Column width={14}>
          <LocalizedMenu
            languages={addedLangs}
            contents={localizedContents}
            icons={this.renderMenuIcons()}
            showAddLanguage={allowAddLang}
            onUpdateLanguages={this.handleUpdateLanguages}
            languagesAllowedToToggle={languagesInTemplate}
            defaultLangAutoSelect={false}
          />
        </Grid.Column>
      </Grid>
    );
  }
}
